import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { GC_AND_PROMO_CONSTRAINTS } from 'constants/constraintViolations';

import RedeemableRewards from 'components/checkout/melody/RedeemableRewards';
import css from 'styles/components/checkout/melody/payment/paymentCouponCode.scss';
import { onChangeRedemptionAmountEvent, onRedeemRewardsComponentView } from 'actions/account/rewards';

export class PaymentCouponCode extends Component {
  state = {
    isOpen: false,
    couponCode: ''
  };

  componentDidMount() {
    const { isOpen } = this.state;
    const { openByDefault } = this.props;

    if (isOpen !== openByDefault) {
      this.setState({ isOpen: !isOpen });
    }
  }

  componentDidUpdate(prevProps) {
    const { location: { pathname: prevPathName } } = prevProps;
    const { location: { pathname: nextPathName } } = this.props;

    if (prevPathName !== nextPathName) {
      this.setState({ couponCode: '' });
    }
  }

  toggleIsOpen = e => {
    e.preventDefault();
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  onTypeCouponCode = e => {
    const { target: { value } } = e;
    this.setState({ couponCode: value });
  }

  onSubmitCoupon = e => {
    e.preventDefault();
    const { onAddCouponClick } = this.props;
    const { couponCode } = this.state;
    onAddCouponClick(couponCode);
  }

  render() {
    const { testId = f => f, marketplace: { checkout: { melodyCouponCodeVerbiage } } } = this.context;
    const { couponCode, isOpen } = this.state;
    const {
      hideRewardsRedemption,
      constraintViolations,
      isRedeemingRewards,
      onRedeemRewardsPoints,
      purchaseDataIsLoading,
      redeemableRewards,
      redeemingRewardsStatus,
      spendPointDollarValue,
      spendPoints,
      onRedeemRewardsComponentView,
      onChangeRedemptionAmountEvent
    } = this.props;
    let errorMsg = false;

    Object.keys(constraintViolations).some(key => {
      errorMsg = GC_AND_PROMO_CONSTRAINTS.includes(key) && constraintViolations[key].message;
      return !!errorMsg;
    });

    return (
      <>
        <button
          type="button"
          className={css.toggleBtn}
          onClick={this.toggleIsOpen}
          data-test-id={testId('giftCardPromoArea')}>
          <p className={cn({ [css.arrowDown]: !isOpen, [css.arrowUp]: isOpen })}>{melodyCouponCodeVerbiage}</p>
        </button>

        {
          isOpen && <div>
            <form
              data-test-id={testId('addCouponForm')}
              onSubmit={this.onSubmitCoupon}
              method="POST"
              action="/marty/checkout/coupon"
              className={css.couponBar}
              data-search-container>
              <input
                className={cn({ [css.error]: !!errorMsg })}
                onChange={this.onTypeCouponCode}
                value={couponCode}
                id="code"
                name="code"
                data-test-id={testId('giftCardCodeInput')}
                required={true}
                autoComplete="off"
                placeholder="Enter Code" />
              <button type="submit" disabled={purchaseDataIsLoading} data-test-id={testId('giftCardCodeSubmit')}>Apply</button>
            </form>
            { !!errorMsg && <div className={css.errorMsg} data-test-id={testId('giftCardCodeError')}>{ errorMsg }</div> }
          </div>
        }

        <RedeemableRewards
          hideRewardsRedemption={hideRewardsRedemption}
          isRedeemingRewards={isRedeemingRewards}
          onRedeemRewardsPoints={onRedeemRewardsPoints}
          redeemableRewards={redeemableRewards}
          redeemingRewardsStatus={redeemingRewardsStatus}
          spendPointDollarValue={spendPointDollarValue}
          spendPoints={spendPoints}
          onChangeRedemptionAmount={onChangeRedemptionAmountEvent}
          onRedeemRewardsComponentView={onRedeemRewardsComponentView} />
      </>
    );
  }
}

PaymentCouponCode.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

const mapStateToProps = ({ routing }) => ({ location: routing.locationBeforeTransitions });

export default connect(mapStateToProps, {
  onChangeRedemptionAmountEvent,
  onRedeemRewardsComponentView
})(PaymentCouponCode);
